import React from "react";
import { Oval } from "react-loader-spinner";
import "./Loader.css";

const Loader = (props) => {
	return (
		<Oval
			height={props.height || 60}
			width={props.width || 60}
			color={"white"}
			wrapperStyle={props.style}
			wrapperClass="loader-wrapper"
			visible={true}
			ariaLabel="oval-loading"
			secondaryColor={props.secondaryColor || "#0C86C6"}
			strokeWidth={props.strokeWidth || 2}
			strokeWidthSecondary={2}
		/>
	);
};

export default Loader;
